import { render, staticRenderFns } from "./AwardsAndRecognitions.vue?vue&type=template&id=a2c5f918&scoped=true&"
var script = {}
import style0 from "./AwardsAndRecognitions.vue?vue&type=style&index=0&id=a2c5f918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c5f918",
  null
  
)

export default component.exports